import { supabaseClient } from 'supabase'
import { EventRow } from './deskTypes'

/**
 * The published event a candidate matches (duplicate or update proposal). The
 * match panel needs the whole row, including `uid` for the `/Events/:uid` link.
 */
export const queryDeskTargetEvent = async (eventId: number): Promise<EventRow> => {
  const { data, error } = await supabaseClient
    .from('events')
    .select('*')
    .eq('id', eventId)
    .single()

  if (error) {
    throw error
  }
  return data
}
